import { FindingStatusSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { FindingSeveritySchema } from '@terra/shared-schemas-orchestrator';

export const RequiredFieldDefaultSchema = z.union([
  z.object({
    terraField: z.string(),
    label: z.string().optional(),
  }),
  z.object({
    value: z.string(),
    label: z.string().optional(),
  }),
]);

export type RequiredFieldDefault = z.infer<typeof RequiredFieldDefaultSchema>;

export const OptionalFieldDefaultSchema = z.object({
  value: z.string(),
});

export type OptionalFieldDefault = z.infer<typeof OptionalFieldDefaultSchema>;

export const TicketingProviderSettingsSchema = z.object({
  cloudId: z.string().optional(),
  projectId: z.string().optional(),
  projectName: z.string().optional(),
  applicationProjectOverrides: z.record(z.string(), z.string()).optional(),
  issueTypeName: z.string().optional(),
  statusMappings: z
    .array(
      z.object({
        providerStatusId: z.string(),
        providerStatusLabel: z.string(),
        terraStatus: FindingStatusSchema.nullable(),
      }),
    )
    .optional(),
  requiredFieldDefaults: z
    .record(z.string(), RequiredFieldDefaultSchema)
    .optional(),
  optionalFieldDefaults: z
    .record(z.string(), OptionalFieldDefaultSchema)
    .optional(),
  findingConditions: z
    .object({
      minSeverity: FindingSeveritySchema.optional(),
      severities: z.array(FindingSeveritySchema).optional(),
    })
    .optional(),
  descriptionTemplate: z.string().optional(),
  attachPocWhenAvailable: z.boolean().optional(),
});

export type TicketingProviderSettings = z.infer<
  typeof TicketingProviderSettingsSchema
>;
